import type { SurveyAnswer } from '@/data-access/surveys/types'
import type { Option } from '@/components/poll/PollCard'

// Map of answer descriptions to corresponding icons
export const ICON_MAPPING = {
	'Do nothing, let the CHZ pile up & wait for better market conditions': '/images/do-nothing.webp',
	'Distribute $CHZ to $PEPPER stakers': '/images/total-supply.webp',
	'Buy and burn $PEPPER': '/images/burn.webp',
	'Buy and hold $PEPPER': '/images/hold.webp',
	// Icon to be updated once provided by Design team
	'Move $CHZ into “CEX Fund” (to be used to pursue Tier 1 listing)': '/images/money-pot.svg'
} as const

/**
 * Converts survey answers into formatted poll options
 * @param poll The poll object containing answers
 * @returns Formatted poll options with descriptions, values, icons, and vote counts
 */
export function getPollOptions(pollAnswers: SurveyAnswer[]): Option[] {
	return pollAnswers.map((answer: SurveyAnswer) => ({
		description: answer.id,
		value: answer.id,
		icon: ICON_MAPPING[answer.id] || '/images/custom-answer.webp',
		votes: answer.totalVotes ?? 0n,
		tokens: answer.totalTokens ?? 0n
	}))
}
